import type { Win, Loading, AppSettings } from '../types'

const win: Win = {
	w: window.innerWidth,
	h: window.innerHeight,
}

const loading: Loading = {
  	value: false
}

const appSettings: AppSettings = {
	jsNavigation: (wp_settings && wp_settings.js_navigation == 1) ? 1 : 0,
	navigationCache: (wp_settings && wp_settings.navigation_cache == 1) ? 1 : 0,
	smoothScroll: (wp_settings && wp_settings.smooth_scroll == 1) ? 1 : 0,
	scrollSmoothness: wp_settings && wp_settings.scroll_smoothness ? parseFloat(wp_settings.scroll_smoothness) : 92,
	pageTransitionEnabled: true,
	scroller: document.querySelector('[data-scroll-wrapper]'),
}

const app_env = wp_settings ? wp_settings.app_env : undefined

export { win, loading, appSettings, app_env }
